var PLACEMENTS = {
    SHOW_ON_HOVER: 'SHOW_ON_HOVER',
    SHOW_BELOW: 'SHOW_BELOW',
    SHOW_ABOVE: 'SHOW_ABOVE',
    SHOW_ON_THE_RIGHT: 'SHOW_ON_THE_RIGHT',
    SHOW_ON_THE_LEFT: 'SHOW_ON_THE_LEFT',
    ALTERNATE_HORIZONTAL: 'ALTERNATE_HORIZONTAL',
    ALTERNATE_VERTICAL: 'ALTERNATE_VERTICAL',
};
var hasHoverPlacement = function (placement) {
    return String(placement).indexOf(PLACEMENTS.SHOW_ON_HOVER) >= 0;
};
var hasExternalAbovePlacement = function (placement, idx) {
    return String(placement).indexOf(PLACEMENTS.SHOW_ABOVE) >= 0 ||
        (idx % 2 === 0 &&
            String(placement).indexOf(PLACEMENTS.ALTERNATE_VERTICAL) >= 0);
};
var hasExternalBelowPlacement = function (placement, idx) {
    return String(placement).indexOf(PLACEMENTS.SHOW_BELOW) >= 0 ||
        (idx % 2 === 1 &&
            String(placement).indexOf(PLACEMENTS.ALTERNATE_VERTICAL) >= 0);
};
var hasExternalRightPlacement = function (placement, idx) {
    return String(placement).indexOf(PLACEMENTS.SHOW_ON_THE_RIGHT) >= 0 ||
        (idx % 2 === 0 &&
            String(placement).indexOf(PLACEMENTS.ALTERNATE_HORIZONTAL) >= 0);
};
var hasExternalLeftPlacement = function (placement, idx) {
    return String(placement).indexOf(PLACEMENTS.SHOW_ON_THE_LEFT) >= 0 ||
        (idx % 2 === 1 &&
            String(placement).indexOf(PLACEMENTS.ALTERNATE_HORIZONTAL) >= 0);
};
var hasExternalVerticalPlacement = function (placement) {
    return hasExternalAbovePlacement(placement, 0) ||
        hasExternalBelowPlacement(placement, 1);
};
var hasExternalHorizontalPlacement = function (placement) {
    return hasExternalRightPlacement(placement, 0) ||
        hasExternalLeftPlacement(placement, 1);
};
var isExternalVerticalPlacement = function (placement) {
    return hasExternalVerticalPlacement(placement) &&
        !hasExternalHorizontalPlacement(placement) &&
        !hasHoverPlacement(placement);
};
var isExternalHorizontalPlacement = function (placement) {
    return hasExternalHorizontalPlacement(placement) &&
        !hasExternalVerticalPlacement(placement) &&
        !hasHoverPlacement(placement);
};
var isExternalAbovePlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_ABOVE;
};
var isExternalBelowPlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_BELOW;
};
var isExternalAboveOrBelowSinglePlacement = function (placement) {
    return isExternalAbovePlacement(placement) || isExternalBelowPlacement(placement);
};
var isHoverPlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_ON_HOVER;
};
var isExternalRightPlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_ON_THE_RIGHT;
};
var isExternalLeftPlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_ON_THE_LEFT;
};
var isConstantVerticalPlacement = function (placement, isSlideshow) {
    var placementArray = placement.split(',');
    var firstPlacement = placementArray.shift();
    return (isSlideshow || // Either SlideShow OR all placements are above/below (the same as the first one)
        (isExternalAboveOrBelowSinglePlacement(firstPlacement) &&
            placementArray.every(function (placement) { return placement === firstPlacement; })));
};
export default PLACEMENTS;
export { hasExternalAbovePlacement, hasExternalBelowPlacement, hasHoverPlacement, hasExternalRightPlacement, hasExternalLeftPlacement, hasExternalVerticalPlacement, hasExternalHorizontalPlacement, isExternalAbovePlacement, isExternalBelowPlacement, isHoverPlacement, isExternalRightPlacement, isExternalLeftPlacement, isExternalVerticalPlacement, isExternalHorizontalPlacement, isConstantVerticalPlacement, };
//# sourceMappingURL=placements.js.map